<div class="drawer-header flex-row-horizontal-space-between-vertical-center">
  <h2 class="title" id="help-drawer-title" i18n>What's new</h2>
  <button
    (click)="closeDrawer.emit()"
    mat-icon-button
    type="button"
    class="button-with-variable"
    aria-label="Close the What's new panel"
    i18n-aria-label
  >
    <mat-icon class="material-icons-outlined">close</mat-icon>
  </button>
</div>

<mat-divider></mat-divider>

<div class="drawer-content flex-column">
  @for (highlight of highlights; track highlight; let last = $last) {
    @if (highlight.image) {
      <div
        class="drawer-content__image-container"
        [style.min-height]="highlight.imageHeight ? null : '96px'"
      >
        @if (highlight.imageHeight) {
          <img
            [alt]="highlight.imageAlt"
            [height]="highlight.imageHeight"
            [width]="highlight.imageWidth"
            [ngSrc]="'assets/images/highlights/' + highlight.image"
          />
        } @else {
          <img
            [alt]="highlight.imageAlt"
            fill
            [ngSrc]="'assets/images/highlights/' + highlight.image"
          />
        }
      </div>
    }

    <h3 class="drawer-content__title">{{ highlight.title }}</h3>

    <div class="flex-row">
      @for (tag of highlight.tags; track tag) {
        @if (tag === HighlightType.RELEASE) {
          <div class="drawer-content__chip">
            <mat-icon class="drawer-content__chip__icon" fontSet="material-icons-outlined">
              rocket
            </mat-icon>
            <span class="drawer-content__chip__tag" i18n>Release</span>
          </div>
        } @else if (tag === HighlightType.FEATURE) {
          <div class="drawer-content__chip feature">
            <mat-icon class="drawer-content__chip__icon" fontSet="material-icons-outlined">
              auto_awesome
            </mat-icon>
            <span class="drawer-content__chip__tag" i18n>Feature</span>
          </div>
        } @else if (tag === HighlightType.DOCUMENTATION) {
          <div class="drawer-content__chip documentation">
            <mat-icon class="drawer-content__chip__icon" fontSet="material-icons-outlined">
              menu_book
            </mat-icon>
            <span class="drawer-content__chip__tag" i18n>Doc</span>
          </div>
        } @else if (tag === HighlightType.WIDGET) {
          <div class="drawer-content__chip widget">
            <mat-icon class="drawer-content__chip__icon" fontSet="material-icons-outlined">
              widgets
            </mat-icon>
            <span class="drawer-content__chip__tag" i18n>Widget</span>
          </div>
        } @else if (tag === HighlightType.ENHANCEMENT) {
          <div class="drawer-content__chip enhancement">
            <mat-icon class="drawer-content__chip__icon" fontSet="material-icons-outlined">
              auto_fix_high
            </mat-icon>
            <span class="drawer-content__chip__tag" i18n>Enhancement</span>
          </div>
        }
      }
    </div>

    <app-markdown-viewer [text]="highlight.description"></app-markdown-viewer>

    @if (highlight.link) {
      <a
        class="drawer-content__learn-more-button"
        [href]="highlight.link"
        target="_blank"
        matButton="outlined"
      >
        <span i18n>Learn more</span>
        <span class="drawer-content__learn-more-context" i18n>
          about {{ highlight.title }}, opens in a new tab</span
        >
      </a>
    }

    @if (!last) {
      <mat-divider class="drawer-content__divider"></mat-divider>
    }
  }
</div>
